import styled from '@emotion/styled'

import { COLORS } from '@/styles/colors'

import { LANDING_COLORS } from '../../../constants'

export const ComparisonContainer = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
  padding: 60px 0;
  background-color: ${COLORS.bgWhite};
`

export const ComparisonHeading = styled.h2`
  margin: 0;
  font-size: 30px;
  font-weight: 700;
  line-height: 30px;
  letter-spacing: -0.45px;
  text-align: center;
  color: ${COLORS.textPrimary};
`

export const ComparisonBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  width: 100%;
`

export const ComparisonImage = styled.img`
  align-self: center;
  width: 262px;
  height: auto;
`

export const QnaList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: 0;
  padding: 0 40px 0 60px;
  list-style: none;
`

export const QnaItem = styled.li`
  display: flex;
  gap: 8px;
  align-items: flex-start;
`

export const QnaCheckIcon = styled.img`
  flex-shrink: 0;
  width: 14px;
  height: 14px;
`

export const QnaText = styled('p', {
  shouldForwardProp: (prop) => prop !== 'highlighted',
})<{ highlighted: boolean }>`
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  line-height: 14px;
  letter-spacing: -0.21px;
  color: ${({ highlighted }) => (highlighted ? LANDING_COLORS.brand : COLORS.textTertiary)};
`
